import { render, staticRenderFns } from "./DossierEditAutoFillModalField.vue?vue&type=template&id=bdd5bae8"
import script from "./DossierEditAutoFillModalField.vue?vue&type=script&lang=ts"
export * from "./DossierEditAutoFillModalField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdd5bae8')) {
      api.createRecord('bdd5bae8', component.options)
    } else {
      api.reload('bdd5bae8', component.options)
    }
    module.hot.accept("./DossierEditAutoFillModalField.vue?vue&type=template&id=bdd5bae8", function () {
      api.rerender('bdd5bae8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/DossierEditAutoFillModalField.vue"
export default component.exports